<kendo-dialog-titlebar>
    {{'claims-center.claimDocumentation.documentListToExport' | translate}}
    <span *ngIf="docsCount > 0">{{' - '}} {{'claims-center.claimDocumentation.selectedDocsForExportCounter' |
        translate}} : {{docsCount}} </span>
</kendo-dialog-titlebar>

<div>

    <div fxLayout="column" class="export-docs-box form-block">

        <kendo-grid [data]="selectedDocsInfos$ | async" [loading]="this.isLoading" [size]="'small'">

            <kendo-grid-column field="name" title="{{'claims-center.claimDocumentation.documentType' | translate}}" [width]="200">
                <ng-template kendoGridCellTemplate let-document="dataItem">
                    <app-document-info-description [documentInfo]="document"></app-document-info-description>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="name" title="{{'claims-center.claimDocumentation.name' | translate}}" [width]="300">
                <ng-template kendoGridCellTemplate let-document="dataItem">
                    <div fxLayout="column">
                        <strong>{{ document.nameForExport }}</strong>
                        <span>{{ document.name }}</span>
                    </div>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="timestamp" title="{{'claims-center.claimDocumentation.addingDate' | translate}}" [width]="80">
                <ng-template kendoGridCellTemplate let-document="dataItem">
                    <div fxLayout="column">
                    <span>{{document.timestamp | date:'yyyy-MM-dd HH:mm:ss' }}</span>
                    <span>{{document.createdBy }}</span>
                    </div>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="exportInfo" title="{{'claims-center.claimDocumentation.exportInfo' | translate}}" [width]="50">
                <ng-template kendoGridCellTemplate let-document="dataItem" >
                    <kendo-badge-container *ngIf="document.isAudanetExported"  
                            title="{{document.audanetExportedBy}}({{document.audanetExportedTimestamp}})">
                        <img src="./assets/img/audatex_logo.jpg" [width]="48" alt="audanet"/>
                    
                        <kendo-badge size="small" themeColor="success" 
                            [align]="align" [position]="'inside'" >
                            <kendo-icon  [name]="'upload'" ></kendo-icon>
                        </kendo-badge>
                    
                    </kendo-badge-container>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="actions" title="" [width]="40">
                <ng-template kendoGridCellTemplate let-document="dataItem">
                    <div fxLayout="row" fxLayoutAlign="center center">
                        <button kendoButton look="flat" icon="delete" (click)="removeFromExport(document.id)"> </button>
                        <button kendoButton look="flat" icon="image" (click)="showContent(document)"> </button>
                        <button kendoButton look="flat" icon="download" (click)="downloadSingleFile(document)"> </button>
                    </div>
                </ng-template>
            </kendo-grid-column>

        </kendo-grid>
    </div>


</div>
<app-loading-panel [isLoading]="isFileGenerating" [size]="'small'"></app-loading-panel>
<kendo-dialog-actions  fxLayout="row" fxLayoutAlign="center center">
    <button kendoButton (click)="cancel()">{{'global.cancel' | translate}}</button>
    
    <button kendoButton (click)="exportAsZip()" [primary]="true" type="button" [disabled]="isFileGenerating">
        <span>{{'claims-center.claimDocumentation.exportAsZip' | translate}}</span>
        
    </button>
    
    <button kendoButton (click)="showLinkInfoBox()" [primary]="true" type="button" [disabled]="isFileGenerating">
        <span>{{'claims-center.claimDocumentation.exportAsLink' | translate}}</span>
    </button>

    <button kendoButton (click)="exportToAudanet()" [primary]="true" type="button" [disabled]="isFileGenerating">
        <kendo-icon  [name]="'upload'"  [size]="'medium'"></kendo-icon>
        <img src="./assets/img/audatex_logo.jpg" [width]='64' alt="audatex" />
    </button>

    <button kendoButton (click)="generateImageSetPdf()" [primary]="true" type="button" [disabled]="isFileGenerating">
        <span>{{'claims-center.claimDocumentation.generateImageSetPdf' | translate}}</span>
    </button>
</kendo-dialog-actions>

<div kendoDialogContainer #exportListDialog></div>
<div kendoDialogContainer #exportAsLink></div>